module.exports = __webpack_public_path__ + "img/pcba_06@2x.1e9b42d9.png";